module.exports = window["Bernie_l10nBundle_fr_FR"];